import { useLocalStore } from 'mobx-react';
import { meeting as meetingModel, members, note } from '@/models';
import { find } from 'lodash';
import { message } from '@/components';
import { useIntl } from 'umi';
import { elkLog } from '@/utils/elkReport';
import { NoteAuth } from '@/models/note';
export interface NoteStatusChangeResp {
  channelId: string; // 会议房间ID
  shareAnnotateEnabled: boolean; //共享批注是否开启
  shareMemberUid: string; // 开启（关闭）批注时，正在共享的用户 uid
  shareMemberDeviceId: String; //开启（关闭）批注时，正在共享的参会设备 ID
  shareSourceWidth: number; // 共享屏幕宽度
  shareSourceHeight: number; // 共享屏幕高度
  shareAnnotateWbYxAuthArgs: any; // 共享屏幕批注白板认证参数
  annotateMemberUid: string; // 共享屏幕批注时，正在共享的用户 uid
}
export default function useNoteStatusChange() {
  const { formatMessage } = useIntl();

  const { meeting } = useLocalStore(() => {
    return {
      meeting: meetingModel,
    };
  });

  const change = async (body: NoteStatusChangeResp) => {
    if (isMobile) {
      return;
    }
    if (body.shareAnnotateEnabled) {
      const annotateMemberName = find(meeting?.info?.members, {
        uid: body.annotateMemberUid,
      })?.memberName;
      message.info({
        content: formatMessage({ id: 'openAnnotate' }, { name: annotateMemberName }),
        noIcon: true,
      });
      note.setShareAnnotateEnabled(true);
      note.setOriginSize(body.shareSourceWidth, body.shareSourceHeight);
      note.setShareAnnotateAuth(body.shareAnnotateWbYxAuthArgs);
    } else {
      note?.setIsWebOpenNote(false);
      note.setShareAnnotateEnabled(false);
      note.setOriginSize(0, 0);
      note.clearShareAnnotateWbYxAuth();
    }
  };
  return change;
}
